import { CountryPicturesService } from './../../../@core/mock/country-pictures.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { map} from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbComponentSize, NbMediaBreakpointsService, NbThemeService } from '@nebular/theme';
import { Picture } from '../../../@core/data/country-picture';
import { Router } from '@angular/router';


@Component({
  selector: 'ngx-country-pictures',
  styleUrls: ['./country-pictures.component.scss'],
  templateUrl: './country-pictures.component.html',
})
export class CountryPicturesComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  cameras: Picture[];
  selectedCamera: Picture;
  isSingleView = false;
  actionSize: NbComponentSize = 'medium';
  subscription: any;
  subscription2: any;
  countryName: string;

  constructor(
    private themeService: NbThemeService,
    private breakpointService: NbMediaBreakpointsService,
    countryPicturesService: CountryPicturesService,
    private route: Router,) {

    this.subscription = countryPicturesService.countryNameChanges.subscribe(() => {
      this.countryName = countryPicturesService.countryName;
      console.log('mise a jour nom du pays : ', this.countryName);
    });

    this.subscription2 = countryPicturesService.camerasChanges.subscribe(() => {
      this.cameras = countryPicturesService.cameras;
      this.selectedCamera = this.cameras[0];
      console.log('mise a jour photo du pays : ', this.cameras);
    });

  }



  ngOnInit() {

    const breakpoints = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(map(([, breakpoint]) => breakpoint.width))
      .subscribe((width: number) => {
        this.actionSize = width > breakpoints.md ? 'medium' : 'small';
      });

      this.showRegionPictures(this.route.url);
  }

  showRegionPictures(url: string) {
    if (url === '/pages/afrique') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/africa1.jpg', }, {title: '', source: 'assets/region-pictures/africa2.jpg', },
      {title: '', source: 'assets/region-pictures/africa3.jpg', }, {title: '', source: 'assets/region-pictures/africa4.jpg', }, ] 
    }
    if (url === '/pages/amerique') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/america1.jpg', }, {title: '', source: 'assets/region-pictures/america2.jpg', },
      {title: '', source: 'assets/region-pictures/america3.jpg', }, {title: '', source: 'assets/region-pictures/america4.jpg', }, ] 
    }
    if (url === '/pages/amerique-du-nord') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/northamerica1.jpg', }, {title: '', source: 'assets/region-pictures/northamerica2.jpg', },
      {title: '', source: 'assets/region-pictures/northamerica3.jpg', }, {title: '', source: 'assets/region-pictures/northamerica4.jpg', }, ] 
    }
    if (url === '/pages/amerique-du-sud') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/southamerica1.jpg', }, {title: '', source: 'assets/region-pictures/southamerica2.jpg', },
      {title: '', source: 'assets/region-pictures/southamerica3.jpg', }, {title: '', source: 'assets/region-pictures/southamerica4.jpg', }, ] 
    }
    if (url === '/pages/amerique-centrale') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/centraleamerica1.png', }, {title: '', source: 'assets/region-pictures/centraleamerica2.jpg', },
      {title: '', source: 'assets/region-pictures/centraleamerica3.jpg', }, {title: '', source: 'assets/region-pictures/centraleamerica4.jpg', }, ] 
    }
    if (url === '/pages/asie') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/asia1.png', }, {title: '', source: 'assets/region-pictures/asia2.jpg', },
      {title: '', source: 'assets/region-pictures/asia3.jpg', }, {title: '', source: 'assets/region-pictures/asia4.jpg', }, ] 
    }
    if (url === '/pages/caraibes') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/caraibes1.jpg', }, {title: '', source: 'assets/region-pictures/caraibes2.jpg', },
      {title: '', source: 'assets/region-pictures/caraibes3.jpg', }, {title: '', source: 'assets/region-pictures/caraibes4.jpg', }, ] 
    }
    if (url === '/pages/europe') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/europe1.jpg', }, {title: '', source: 'assets/region-pictures/europe2.jpg', },
      {title: '', source: 'assets/region-pictures/europe3.jpg', }, {title: '', source: 'assets/region-pictures/europe4.jpg', }, ] 
    }
    if (url === '/pages/moyen-orient') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/moyenorient1.gif', }, {title: '', source: 'assets/region-pictures/moyenorient2.jpg', },
      {title: '', source: 'assets/region-pictures/moyenorient3.jpg', }, {title: '', source: 'assets/region-pictures/moyenorient4.jpg', }, ] 
    }
    if (url === '/pages/ocean-atlantique') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/oceanatlantique1.gif', }, {title: '', source: 'assets/region-pictures/oceanatlantique2.jpg', },
      {title: '', source: 'assets/region-pictures/oceanatlantique3.jpg', }, {title: '', source: 'assets/region-pictures/oceanatlantique4.jpg', }, ] 
    }
    if (url === '/pages/ocean-indien') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/oceanindien1.png', }, {title: '', source: 'assets/region-pictures/oceanindien2.jpg', },
      {title: '', source: 'assets/region-pictures/oceanindien3.jpg', }, {title: '', source: 'assets/region-pictures/oceanindien4.jpg', }, ] 
    }
    if (url === '/pages/ocean-pacifique') {
      this.cameras = [{title: 'Carte', source: 'assets/region-pictures/oceanpacifique1.jpg', }, {title: '', source: 'assets/region-pictures/oceanpacifique2.jpg', },
      {title: '', source: 'assets/region-pictures/oceanpacifique3.jpg', }, {title: '', source: 'assets/region-pictures/oceanpacifique4.jpg', }, ] 
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectCamera(camera: any) {
    this.selectedCamera = camera;
    this.isSingleView = true;
  }
}
